import { useEffect, useRef } from 'react';
import { findNodeHandle } from 'react-native';

export const usePatchedSvgPathRef = () => {
  const ref = useRef<any>(null);

  useEffect(() => {
    if (ref.current == null) return;

    const node = findNodeHandle(
      ref.current,
    ) as unknown as SVGPathElement | null;

    // $hack(eric): Animated.createAnimatedComponent does not work if
    // setNativeProps is not defined. This is really a hack. Try to find
    // a sophisticated solution later.
    ref.current.setNativeProps = (arg: { style: any }) => {
      for (const p in arg.style) {
        node?.setAttribute(p, arg.style[p]);
      }
    };
  }, []);

  return ref;
};
